import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import GreyArrow from "./images/next.svg";
import { getFastlyImage } from "../../../utils/helpers/get-image-from-path";
import { imageTypes } from "../../../utils/helpers/cdn-image-url";

const isPriceFilter = ({filter}) => {
    return (filter || {}).name === "quotedPrice";
};

const MoreCarsForYouCard = ({
    item,
    config}) => {

    const { image, title, availableCars } = item;

    const renderCard = () => {
        return (
            <React.Fragment>
                <img src={getFastlyImage(config, image, imageTypes.galleryRevamp)}  />
                <div className="media-body">
                    <p styleName={"styles.heading"}>{title}</p>
                    <span styleName={"styles.subHeading"}>
                        <p>
                            {availableCars}<img src={GreyArrow} />
                        </p>
                    </span>
                </div>
            </React.Fragment>
        );
    };

    return (
        <React.Fragment>
            {
                isPriceFilter(item) ?
                    <a href={item.seoPath} className="media" styleName={"styles.outer"}>
                        {renderCard()}
                    </a> :
                    <a  href={item.seoPath} className="media" styleName={"styles.outer"}>
                        {renderCard()}
                    </a>
            }
        </React.Fragment>
    );
};

MoreCarsForYouCard.propTypes = {
    image: PropTypes.string,
    heading: PropTypes.string,
    subHeading: PropTypes.string,
    item: PropTypes.object,
    allFilters: PropTypes.object,
    updateSelectedOnScreenFilterConnect: PropTypes.func,
    reloadCarListConnect: PropTypes.func,
    clearAllFiltersConnect: PropTypes.func,
    updateAppliedFiltersConnect: PropTypes.func,
    resetCarListConnect: PropTypes.func,
    config: PropTypes.object
};

export default MoreCarsForYouCard;
